<style lang="scss">
.dashboard {
  .hg-button-enter {
    background-color: $blue;
    color: white;
  }
}
</style>

<template>
  <!-- eslint-disable -->
  <div class="mb-4 dashboard">
    <div class="max-page-width-small">
      <span v-if="isElectron" class="font-weight-bolder py-2 d-inline-block pointer electron-only"
            @click="$store.dispatch('backToTerminal')"><i class="fa fa-chevron-left"></i> Back to Terminal</span>

      <h2 class="mb-2">Enter your pre call password</h2>

      <b-form-input cy="identifier-input" @keyup.enter="getCalls" @input="onOffsiteIdentifierChange"
                    placeholder="Enter your identifier" v-model="offsiteidentifier"></b-form-input>

      <b-card no-body class="mb-0 mt-4">
        <div class="simple-keyboard"></div>
      </b-card>
    </div>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import {mapState} from 'vuex';
import CallService from '@/services/CallService';
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';

export default {
  name: 'Dashboard',
  components: {},
  data() {
    return {
      loading: false,
      offsiteidentifier: '',
      keyboard: null,
      caps: false,
      calls: [],
      idleTimeAllowed: 15,
      idleTimer: null,
    };
  },
  computed: {
    ...mapState({
      isElectron: state => state.isElectron,
    }),
  },
  mounted() {
    this.setUpKeyboard();
    // this.startInactivityTimer();
  },
  beforeDestroy() {
    clearTimeout(this.idleTimer);
  },
  methods: {
    setUpKeyboard() {
      this.keyboard = new Keyboard({
        onChange: inputValue => {
          this.offsiteidentifier = inputValue;
        },
        onKeyPress: key => {
          if (key === '{enter}') {
            this.getCalls();
          }

          if (key === '{lock}') {
            this.changeKeyboardLayout();
          }
        },
        layout: {
          default: [
            '1 2 3 4 5 6 7 8 9 0',
            'Q W E R T Y U I O P',
            'A S D F G H J K L',
            'Z X C V B N M',
            '{lock} {bksp} {enter}',
          ],
          shift: [
            '1 2 3 4 5 6 7 8 9 0',
            'q w e r t y u i o p',
            'a s d f g h j k l',
            'z x c v b n m',
            '{lock} {bksp} {enter}',
          ],
        },
        display: {
          '{bksp}': '< BACKSPACE',
          '{enter}': 'SEARCH',
          '{space}': ' ',
          '{lock}': 'Caps',
        },
        buttonTheme: [{
          class: 'osk-enter',
          buttons: '{enter}',
        }],
      });

      this.keyboard.setInput(this.offsiteidentifier);
    },
    onOffsiteIdentifierChange(e) {
      this.keyboard.setInput(e);
    },
    changeKeyboardLayout() {
      this.caps = !this.caps;
      this.keyboard.setOptions({
        layoutName: this.caps ? 'shift' : 'default',
      });
    },
    getCalls() {
      CallService.getCalls(this.offsiteidentifier).then(res => {
        this.calls = res.data;
        this.sortCallsByStartTime();

        if (this.calls.length === 0) {
          this.showToastError();
        } else {
          // eslint-disable-next-line no-underscore-dangle
          this.$router.push({name: 'waiting-room', params: {id: this.calls[0]._id}})
        }
      }).catch(err => {
        console.log('Error getting calls ', err);
        this.showToastError();
      }).finally(() => {
        this.loading = false;
      });
    },
    showToastError() {
      this.$toast.error(`We couldn't find any calls booked with password ${this.offsiteidentifier}`, {
        toastClassName: ['toast-std', 'warning-toast'],
      });
    },
    sortCallsByStartTime() {
      this.calls.sort((a, b) => {
        const dateA = new Date(a.requested_booking_slot_1.start_date_time);
        const dateB = new Date(b.requested_booking_slot_1.start_date_time);
        return dateA - dateB;
      });
    },
    startInactivityTimer() {
      this.trackIdleTime();
      this.detectUserActivity();
    },
    detectUserActivity() {
      document.addEventListener('click', this.trackIdleTime);
      document.addEventListener('mousemove', this.trackIdleTime);
    },
    trackIdleTime() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
      }
      this.idleTimer = setTimeout(() => {
        this.logOutUser();
      }, this.idleTimeAllowed * 1000 * 60);
    },
    logOutUser() {
      if (this.isElectron) {
        this.$store.dispatch('backToTerminal');
      } else {
        this.$store.dispatch('auth/clearLocalUser');
        this.$router.push('/login');
      }
    },
  },
};
</script>
